import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="top" className="relative w-full h-screen min-h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e246740c17bf214ad605a8d6f87dab0b.jpg"
          alt="Hug ヒーロー"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1C1410]/60 via-[#1C1410]/40 to-[#1C1410]/65" />
      </div>

      <div
        className={`relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 transition-all duration-1200 ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className={`transition-all duration-1000 delay-100 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <p className="text-white/60 text-xs tracking-[0.6em] mb-8 uppercase font-light">
            Hug
          </p>
        </div>

        <div className={`transition-all duration-1000 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h1
            className="text-white text-4xl md:text-6xl font-light leading-[1.6] mb-6"
            style={{ fontFamily: 'Noto Serif JP, serif' }}
          >
            人と人を、<br />
            <em className="not-italic font-medium" style={{ color: '#F2D9D9' }}>やさしくつなぐ。</em>
          </h1>
          <p
            className="text-white/75 text-lg md:text-xl font-light mb-10 tracking-wider"
            style={{ fontFamily: 'Noto Serif JP, serif' }}
          >
            命のぬくもりを未来へ。
          </p>
        </div>

        <div
          className={`w-px h-10 bg-white/30 mx-auto mb-10 transition-all duration-1000 delay-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        />

        <div className={`transition-all duration-1000 delay-400 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <p
            className="text-white/65 text-sm leading-loose max-w-md mx-auto mb-10"
            style={{ fontFamily: 'Noto Sans JP, sans-serif', fontWeight: 300 }}
          >
            大切な命の記憶を残すこと。<br />
            Hugは、人と人、命と命をやさしくつなぐ会社です。
          </p>
        </div>

        <div
          className={`flex items-center gap-5 transition-all duration-1000 delay-500 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <button
            onClick={() => scrollToSection('#philosophy')}
            className="px-9 py-3.5 bg-white/95 text-[#3A2E28] text-xs tracking-[0.2em] cursor-pointer hover:bg-white transition-colors duration-300 whitespace-nowrap rounded-sm"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            私たちについて
          </button>
          <button
            onClick={() => scrollToSection('#business')}
            className="px-9 py-3.5 border border-white/60 text-white/90 text-xs tracking-[0.2em] cursor-pointer hover:border-white hover:text-white transition-colors duration-300 whitespace-nowrap rounded-sm"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            事業内容を見る
          </button>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <p className="text-white/40 text-[10px] tracking-[0.3em] uppercase">Scroll</p>
        <div className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent animate-pulse" />
      </div>
    </section>
  );
}
